module.exports = __webpack_public_path__ + "assets/240d8938ab90d232343d756f1156865e.svg";